import { Menu, MenuButton, MenuList, MenuItem, Button, Icon, Box } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { Users, ChevronDown, X } from 'lucide-react';
import { useMemo } from 'react';

import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';
import { iconSize } from '@duke-hq/ui/constants/scalable';

export function AssignedToFilter() {
  const { updateFilters, filters } = useFiltersContext();

  const filterLabel = useMemo(() => {
    if (filters.assignedTo === 'unassigned') {
      return t`Unassigned`;
    }

    if (filters.assignedTo === 'me') {
      return t`Assigned to me`;
    }

    return t`Assigned to anyone`;
  }, [filters.assignedTo]);

  return (
    <Menu>
      <MenuButton
        as={Button}
        leftIcon={<Icon as={Users} boxSize={4} />}
        rightIcon={
          filters.assignedTo !== undefined ? (
            <Box
              minW="fit-content"
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                updateFilters({ assignedTo: undefined });
              }}
              ml={1}
            >
              <X size={iconSize.md} />
            </Box>
          ) : (
            <ChevronDown size={iconSize.md} />
          )
        }
        variant="ghost"
        size="sm"
        fontWeight="normal"
        px={3}
      >
        {filterLabel}
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => updateFilters({ assignedTo: undefined })}>
          <Trans>Assigned to anyone</Trans>
        </MenuItem>
        <MenuItem onClick={() => updateFilters({ assignedTo: 'me' })}>
          <Trans>Assigned to me</Trans>
        </MenuItem>
        <MenuItem onClick={() => updateFilters({ assignedTo: 'unassigned' })}>
          <Trans>Unassigned</Trans>
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
